import { assetUrl } from "utils";
import cx from "classnames";

export type LiteratiLogoProps = {
  className?: string;
};

export const LiteratiLogo = ({ className }: LiteratiLogoProps) => (
  <img
    className={cx("literati-logo", className)}
    src={assetUrl("/static/img/literati-white.svg")}
    alt="literati-logo"
    height="32.6664"
    width="120"
  />
);

export default LiteratiLogo;
